function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 15 15.327"
}, props), /*#__PURE__*/React.createElement("g", {
  id: "Group_4837",
  "data-name": "Group 4837",
  transform: "translate(10)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_4815",
  "data-name": "Group 4815",
  transform: "translate(-10)",
  clipPath: "url(#clip-path)",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_2577",
  "data-name": "Path 2577",
  d: "M13.256 9H12v.76a5 5 0 011.256-.6z",
  transform: "translate(-4.461 -3.346)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Rectangle_2031",
  "data-name": "Rectangle 2031",
  transform: "translate(2.513 3.769)",
  d: "M0 0h1.256v5.654H0z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_2578",
  "data-name": "Path 2578",
  d: "M1.256 11.308V1.256h6.283v2.513h2.513V5.6c.079 0 .157-.012.237-.012a5.048 5.048 0 011.02.1V3.141L8.167 0H.628A.628.628 0 000 .623v11.318a.629.629 0 00.624.623h5.032a4.984 4.984 0 01-.34-1.256z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_2579",
  "data-name": "Path 2579",
  d: "M9.256 11H8v2.513h.386a5 5 0 01.871-1.83z",
  transform: "translate(-2.974 -4.09)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_2580",
  "data-name": "Path 2580",
  d: "M13.589 18.82a4.712 4.712 0 114.711-4.711 4.717 4.717 0 01-4.712 4.712m0-8.167a3.455 3.455 0 103.455 3.455 3.459 3.459 0 00-3.455-3.455",
  transform: "translate(-3.3 -3.494)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_2581",
  "data-name": "Path 2581",
  d: "M14.219 17.676a.627.627 0 01-.444-.184l-1.214-1.214a.628.628 0 01.888-.888l.77.77 2.111-2.111a.628.628 0 11.888.888l-2.556 2.556a.627.627 0 01-.444.184",
  transform: "translate(-4.601 -5.154)"
})))));